<template>
  <header id="grants-header">
    <div class="hero-bg">
      <img
        src="@/assets/img/components/projects/celka.webp"
        alt=""
        aria-hidden="true"
        class="hero-bg-img"
      />
      <div class="hero-overlay" />
    </div>

    <v-container class="hero-content">
      <div class="hero-top">
        <span class="brand-mark">SKNTI</span>
        <span class="brand-meta">{{ $t('grants.page.brand_meta') }}</span>
      </div>

      <div class="hero-mid">
        <h1 v-html="$t('grants.header.title')" />
        <p class="hero-sub">{{ $t('grants.header.subtitle') }}</p>
        <img
          src="@/assets/img/components/thank/Logo_Ministerstwo.webp"
          alt="Ministerstwo Nauki i Szkolnictwa Wyższego"
          class="hero-ministry-logo"
        />
      </div>

      <div class="hero-bottom">
        <div class="fact">
          <span class="fact-label">{{ $t('grants.page.boat_label') }}</span>
          <span class="fact-value">{{ $t('grants.page.boat_value') }}</span>
        </div>
        <div class="fact">
          <span class="fact-label">{{ $t('grants.page.status_label') }}</span>
          <span class="fact-value">{{ $t('grants.page.status_completed') }}</span>
        </div>

        <a href="#editions" class="scroll-down" aria-label="Przewiń">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
            <path d="M12 4v16m0 0l-6-6m6 6l6-6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </a>
      </div>

    </v-container>
  </header>
</template>

<script>
export default {
  name: 'GrantsHeaderComponent'
}
</script>

<style lang="sass" scoped>
  #grants-header
    position: relative
    min-height: 100vh
    color: #fff
    overflow: hidden
    display: flex

  .hero-bg
    position: absolute
    inset: 0
    z-index: 0

    img, .hero-bg-img
      width: 100%
      height: 100%
      object-fit: cover
      object-position: right bottom
      animation: heroZoom 20s ease-out forwards

    .hero-overlay
      position: absolute
      inset: 0
      background: linear-gradient(180deg, rgba(10, 8, 40, 0.55) 0%, rgba(10, 8, 40, 0.15) 28%, rgba(10, 8, 40, 0.4) 70%, rgba(10, 8, 40, 0.95) 100%)

  @keyframes heroZoom
    from
      transform: scale(1.06)
    to
      transform: scale(1)

  .hero-content
    position: relative
    z-index: 2
    display: flex
    flex-direction: column
    width: 100%
    padding: 130px 0 60px

  .hero-top
    display: flex
    align-items: baseline
    gap: 28px
    padding-bottom: 18px
    border-bottom: 1px solid rgba(255, 255, 255, 0.2)

    .brand-mark
      font-family: Inter, sans-serif
      font-weight: 800
      font-size: 0.95em
      letter-spacing: 0.18em
      color: #fff

    .brand-meta
      font-family: Inter, sans-serif
      font-weight: 500
      font-size: 0.82em
      letter-spacing: 0.04em
      color: rgba(255, 255, 255, 0.7)

  .hero-mid
    flex: 1
    display: flex
    flex-direction: column
    align-items: flex-start
    justify-content: center
    padding: 80px 0
    max-width: 820px

  h1
    font-family: Raleway, sans-serif
    font-weight: 900
    font-size: 6.8em
    line-height: 0.92
    letter-spacing: -0.045em
    text-transform: uppercase
    color: #fff
    margin: 0 0 36px
    text-rendering: geometricPrecision

    ::v-deep br
      display: block
      content: ''
      margin-top: -0.05em

  .hero-sub
    font-family: Inter, sans-serif
    font-size: 1em
    line-height: 1.7em
    color: rgba(255, 255, 255, 0.78)
    max-width: 560px
    margin: 0

  .hero-ministry-logo
    height: 80px
    width: auto
    max-width: 360px
    margin-top: 40px
    object-fit: contain
    display: block

  .hero-bottom
    display: grid
    grid-template-columns: auto auto 1fr auto
    gap: 70px
    align-items: center
    padding-top: 26px
    border-top: 1px solid rgba(255, 255, 255, 0.2)

    .scroll-down
      grid-column: 4
      justify-self: end

  .fact
    display: flex
    flex-direction: column
    gap: 6px

    .fact-label
      font-family: Inter, sans-serif
      font-weight: 500
      font-size: 0.78em
      letter-spacing: 0.06em
      color: rgba(255, 255, 255, 0.55)

    .fact-value
      font-family: Raleway, sans-serif
      font-weight: 700
      font-size: 1em
      letter-spacing: -0.005em
      color: #fff

  .scroll-down
    width: 48px
    height: 48px
    border-radius: 50%
    background: #0a0828
    color: #fff
    display: inline-flex
    align-items: center
    justify-content: center
    text-decoration: none
    transition: all 0.3s ease

    &:hover
      background: #fff
      color: #0a0828
      transform: translateY(2px)

  @media only screen and (max-width: 1180px)
    h1
      font-size: 5.2em

  @media only screen and (max-width: 900px)
    .hero-content
      padding: 130px 16px 60px

    h1
      font-size: 3.8em

    .hero-bottom
      grid-template-columns: 1fr 1fr
      gap: 28px

      .scroll-down
        position: absolute
        right: 24px
        bottom: 24px

  @media only screen and (max-width: 600px)
    #grants-header
      min-height: auto

    .hero-content
      padding: 130px 14px 60px

    .hero-top
      flex-direction: column
      align-items: flex-start
      gap: 8px

    h1
      font-size: 2.6em
      margin-bottom: 24px

    .hero-mid
      padding: 60px 0

    .hero-sub
      font-size: 0.95em

    .hero-ministry-logo
      height: 60px
      max-width: 280px
      margin-top: 28px

    .hero-bottom
      grid-template-columns: 1fr
      gap: 20px

      .scroll-down
        position: static
        align-self: flex-start
</style>
